import { useRef } from 'react'
import { GitBranch, Play } from 'lucide-react'
import StagesTab from './StagesTab'
import SectionBlock from '../UI/SectionBlock'
import SectionHeader from '../UI/SectionHeader'

const StagesSection = ({ talentId, talentType, hasPermission }) => {
  const tabRef = useRef(null)
  const canStart = hasPermission('talent-service', talentType, 'read')
    && hasPermission('talent-service', 'playbook_instance', 'create')

  return (
    <SectionBlock id="stages">
      <SectionHeader
        icon={GitBranch}
        title="Stages"
        action={canStart ? (
          <button
            onClick={() => tabRef.current?.openStart()}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white text-xs font-medium rounded-lg hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 transition-colors"
          >
            <Play className="h-3.5 w-3.5" />Start Playbook
          </button>
        ) : null}
      />
      <StagesTab ref={tabRef} talentId={talentId} talentType={talentType} canStart={canStart} />
    </SectionBlock>
  )
}

export default StagesSection
